// extracted by mini-css-extract-plugin
module.exports = {"carousel":"styles_carousel__rjJww","controls":"styles_controls__hvGG9","pagination":"styles_pagination__Ow79r"};